import { FloatingCartButton } from 'src/components/floating-cart-button';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function EcommerceLayout({ children }: Props) {
  return (
    <>
      {/* <Header /> */}

      {children}

      <FloatingCartButton />
    </>
  );
}
